import React from "react";
import "./NavBar.css";

const NavBar = () => {
  return (
    <nav className="navbar">
      {/* Logo – extreme left */}
      <div className="navbar__logo">
        <img src="/logo512.png" alt="Slipstream Logo" />
        <span className="navbar__logo-text">The Slipstream</span>
      </div>

      {/* Right side group */}
      <div className="navbar__right">
        <ul className="navbar__links">
          <li>Benefits</li>
          <li>Specifications</li>
          <li>How-to</li>
          <li>Contact Us</li>
        </ul>

        <div className="navbar__cta">
          <button>
            Do more with video <span>↗</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
